import axios from 'axios'
import { getAge } from 'src/utils/commonMethods'

export const getUserDetailsObject = (proposerData) => {
  const nomineeDetails = {
    nomineeDOB: proposerData.fullQuoteRequest.nomineeDOB,
    nomineeFirstName: proposerData.fullQuoteRequest.nomineeFirstName,
    nomineeGender: proposerData.fullQuoteRequest.nomineeGender,
    nomineeLastName: proposerData.fullQuoteRequest.nomineeLastName,
    nomineeRelationType: proposerData.fullQuoteRequest.nomineeRelationship,
  }

  let currentPolicyDetails = {
    policyType: proposerData.fullQuoteRequest.policyBusinessType,
  }

  let previousPolicyDetails = {
    previousPolicyProvider: {
      insuranceCompanyName:
        proposerData.fullQuoteValues.previousInsuranceProviderName,
    },
    expiryDate: proposerData.fullQuoteRequest.previousPolicyExpiryDate,
    previousPolicyNumber: proposerData.fullQuoteRequest.previousPolicyNumber,
    ncb: proposerData.fullQuoteRequest.previousNCB,
  }

  let vehicleDetails = {
    companyName: '',
    engineNumber: proposerData.fullQuoteRequest.engineNo,
    chassisNumber: proposerData.fullQuoteRequest?.chassisNo,
    loanProviderName: '',
    externalCngLpgKitAmount: proposerData.fullQuoteRequest.cngOrLpgKitAmount,
    regDate: proposerData.fullQuoteRequest.registrationDate,
    vehicleNumber: proposerData.fullQuoteRequest.vehicleNumber,
    vehicleLogo: proposerData.fullQuoteValues.vehicleMakeLogo,
    brand: { genericName: proposerData.fullQuoteValues.makeName },
    model: {
      modelGenericName: proposerData.fullQuoteRequest.vehicleSearchQuery,
    },
    variant: { genericVariantName: proposerData.fullQuoteValues.variantName },
    fuelType: { genericName: proposerData.fullQuoteValues.fuelTypeName },
    vehicleType: proposerData.fieldValues.vehicleType,
  }

  let selectedQuote = {
    ...proposerData.quickQuoteResponse,
  }

  let personalDetails = {
    firstName: proposerData.fullQuoteRequest.firstName,
    lastName: proposerData.fullQuoteRequest.lastName,
    fullAddress: proposerData.fullQuoteRequest.fullAddress,
    mobileNumber: proposerData.fullQuoteRequest.mobile,
    panNumber: proposerData.fullQuoteRequest.panNo,
    email: proposerData.fullQuoteRequest.email,
    pincode: proposerData.fullQuoteRequest.pinCode,
    city: proposerData.fullQuoteRequest.city,
    state: proposerData.fullQuoteRequest.state,
  }

  return {
    vehicleDetails,
    personalDetails,
    currentPolicyDetails,
    selectedQuote,
    previousPolicyDetails,
    nomineeDetails,
  }
}

export const getBrandList = async (token) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/vehiclemakemasterdata`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
export const getModelList = async (token, brandId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/vehiclemodelmasterdata/${brandId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getVariantList = async (token, modelId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/vehiclevariantmasterdata/${modelId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getFuelTypeList = async (token) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/fueltypemasterdata`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getMotorInsuranceDetails = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getmotorfourwheelerquickquotes`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getInsuranceProviderList = async (token) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/insuranceproviders`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getMotorFullQuoteDetails = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getmotorfourwheelerfullquote`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getLoanProviderList = async (token, providerId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getLoanProviders/${providerId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getAddOnsList = async (token) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getMotorAddOns`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getMotorPolicyDetails = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getmotorfourwheelerpolicydetails`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getProposalDetailsMotor = async (token, enquiryId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getmotorfullquoterequest?enquiryId=${enquiryId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const verifyKYCForMotor = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/verifykyc/motor`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const verifyMotorDetails = async (token, vehicleNumber) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getvehicledetails/${vehicleNumber}`,
    headers: { Authorization: `Bearer ${token}` },
  }

  try {
    const response = await axios(config)
    return { data: response.data, status: response.status }
  } catch (error) {
    return {
      error: error.message,
      status: error.response ? error.response.status : null,
    }
  }
}

export const getMotorFullQuoteRequestBody = (motorDetails) => {
  const fullQuoteRequest = {
    providerId: motorDetails.selectedQuote?.providerId,
    enquiryId: motorDetails.selectedQuote?.enquiryId,
    firstName: motorDetails.personalDetails?.firstName,
    lastName: motorDetails.personalDetails?.lastName,
    userName: motorDetails.personalDetails?.name,
    mobile: motorDetails.personalDetails?.mobileNumber,
    email: motorDetails.personalDetails?.email,
    dateOfBirth: motorDetails.personalDetails?.dateOfBirth,
    gender: motorDetails.personalDetails?.gender,
    aadharNo: motorDetails.personalDetails.aadhar,
    state: motorDetails?.personalDetails?.state,
    makeId: motorDetails?.vehicleDetails?.brand?.genericName || '',
    modelId: '',
    variantId: '',
    fuelTypeId: motorDetails.vehicleDetails?.fuelType?.genericName,
    registrationDate: motorDetails.vehicleDetails?.regDate,
    vehicleNumber: motorDetails.vehicleDetails?.vehicleNumber,
    engineNo: motorDetails.vehicleDetails?.engineNumber,
    chassisNo: motorDetails.vehicleDetails?.chassisNumber,
    vehicleLogo: motorDetails.vehicleDetails?.vehicleLogo,
    previousInsuranceProvider:
      motorDetails.previousPolicyDetails?.previousPolicyProvider
        ?.insuranceCompanyFirstName || '',
    previousPolicyExpiryDate: motorDetails.previousPolicyDetails?.expiryDate,
    previousPolicyNumber:
      motorDetails.previousPolicyDetails.previousPolicyNumber,
    claimsOnPreviousPolicy:
      motorDetails.previousPolicyDetails?.existingPolicyClaim === 'yes',
    isVehicleRegisteredUnderCompanyName:
      motorDetails.vehicleDetails?.carOwnedBy === 'company',
    companyName: motorDetails.vehicleDetails?.companyName,
    companyPAN: motorDetails.vehicleDetails?.companyPAN,
    companyGSTIN: motorDetails.vehicleDetails?.companyGSTIN,
    companyIncorporationDate:
      motorDetails?.vehicleDetails?.companyIncorporationDate,
    policyBusinessType: motorDetails.currentPolicyDetails?.policyType,
    payAsYouDrive: false,
    previousNCB: motorDetails.previousPolicyDetails?.ncb,
    cngOrLpgKitAmount: motorDetails.vehicleDetails?.externalCngLpgKitAmount,
    panNo: motorDetails.personalDetails.pan,
    fullAddress: motorDetails.personalDetails?.fullAddress,
    pinCode: motorDetails.personalDetails.pincode,
    city: motorDetails.personalDetails?.city,
    nomineeName: motorDetails.nomineeDetails?.nomineeFirstName,
    nomineeFirstName: motorDetails.nomineeDetails?.nomineeFirstName,
    nomineeLastName: motorDetails.nomineeDetails?.nomineeLastName,
    nomineeDOB: motorDetails.nomineeDetails?.nomineeDOB,
    nomineeAge: getAge(motorDetails.nomineeDetails?.nomineeDOB),
    nomineeRelationship: motorDetails.nomineeDetails?.nomineeRelationType,
    nomineeGender: motorDetails.nomineeDetails?.nomineeGender,
    isPA:
      motorDetails.currentPolicyDetails?.policyType === 'OWN_DAMAGE'
        ? false
        : motorDetails.currentPolicyDetails.paCover,
    addOns: motorDetails.currentPolicyDetails?.addOns,
    idv: motorDetails?.currentPolicyDetails?.idv,
    thirdPartyPolicyExpiryDate:
      motorDetails.previousPolicyDetails.thirdPartyExpiryDate,
    thirdPartyProvider:
      motorDetails?.previousPolicyDetails?.thirdPartyProviderFirstName || '',
    thirdPartyPolicyNo:
      motorDetails?.previousPolicyDetails?.thirdPartyPolicyNo || '',
    thirdPartyStartDate:
      motorDetails?.previousPolicyDetails?.thirdPartyStartDate || '',
    loanProvider: motorDetails.vehicleDetails?.loanProviderName
      ? motorDetails.vehicleDetails?.loanProviderName
      : null,
    loanProviderBranch: motorDetails.vehicleDetails?.branchName,
    vehicleSearchQuery: motorDetails?.vehicleDetails?.model?.modelGenericName,
    manufacturingMonth: motorDetails.vehicleDetails?.monthOfManufacturer,
    manufacturingYear: motorDetails.vehicleDetails?.yearOfManufacturer,
  }

  return fullQuoteRequest
}

export const getPremiumBreakup = async (token, enquiry_Id) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getPremiumBreakup?enquiryId=${enquiry_Id}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const fallbackVehicleInfo = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/fallbackVehicleInfo`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
